import { replaceVar } from './misc';

export const replacePlaceholdersWithBoldTags = (string: string) => string.replace(/\*(.*?)\*/g, '<b>$1</b>'); // from *name* to <b>name</b>

export const replacePlaceholdersWithCustomTags = (string: string, customTag: string): string =>
  string.replace(/\*(.*?)\*/g, customTag); // from *name* to <something>name</something>

export const replacePlaceholdersWithVars = (string: string) => string.replace(/__(.*?)__/g, '{$1}'); // from __name__ to {name}

export const replacePlaceholdersWithValues = (string: string, values: { [key: string]: string }): string => {
  const withKeys = replacePlaceholdersWithVars(string);
  return replaceVar(withKeys, values);
};
